import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { PublicidadDashboard } from 'src/app/shared/model/publicidad-dashboard/publicidadDashboard.model';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { map } from 'rxjs/operators';

const API_URL = environment.apiUrl;

@Injectable({providedIn: 'root'})
export class DashboardService {

    constructor(    private http: HttpClient,     ) { }

    /**
     * Método en cargado de crear la ruta completa para las peticiones
     * @param url // url del recurso al que se desea acceder
     */
    obtenerRutaCompleta = function (url: string) {
        return API_URL + 'controller/' + url;
    };


    consultarpublicidad (req: ConsultaList<PublicidadDashboard>) {
        console.log('consultarpublicidad')

        return this.http.post<ConsultaList<PublicidadDashboard>>(UrlConstantes.consultarPublicidad, req);

    }

      getImagenPublicidad(publicidad: PublicidadDashboard) {
        return this.http.post(UrlConstantes.consultarImagenPublicidad, publicidad, { responseType: 'arraybuffer' });
      }

      guardarTarjetaDePublicidad(publicidad: PublicidadDashboard){
        return this.http.post<PublicidadDashboard>(UrlConstantes.guardaTarjetaDePublicidad, publicidad);
      }

      public guardaImagenPublicidad(data: FormData) {

        return this.http.post<string>(UrlConstantes.guardaImagenPublicidad, data, {
          reportProgress: true,
          observe: 'events'
        }).pipe(map((event) => {
    
          switch (event.type) {
    
            case HttpEventType.UploadProgress:
              const progress = Math.round(100 * event.loaded / event.total);
              return { status: 'progress', message: progress };
    
            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        })
        );
      }
      
      eliminarTarjetaDePublicidad(publicidad: PublicidadDashboard){
        return this.http.post<PublicidadDashboard>(UrlConstantes.eliminarTarjetaDePublicidad, publicidad);
      }

        }